"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserSaleTier = exports.UserSaleTierProvider = void 0;
var constate_1 = __importDefault(require("constate"));
var react_1 = require("react");
var LaunchpadProvider_1 = require("../../LaunchpadProvider");
var hooks_1 = require("../../pool/hooks");
var _tiers_1 = require("../../tiers");
function useUserSaleTierRaw(_a) {
    var _b, _c;
    var _d = _a.doFetch, doFetch = _d === void 0 ? true : _d;
    var levels = (0, LaunchpadProvider_1.useLaunchpadProvider)().levels;
    var _e = (0, hooks_1.usePool)(), sale = _e.pool.sale, userState = _e.userState, refreshUser = _e.refreshUser;
    var _f = (0, react_1.useState)(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = (0, _tiers_1.useUserTier)(), tierState = _g.tierState, isCurrentTierLoading = _g.isLoading;
    var registeredTier = (0, react_1.useMemo)(function () { return (__assign(__assign({}, levels[userState === null || userState === void 0 ? void 0 : userState.tierId]), { multiplier: userState === null || userState === void 0 ? void 0 : userState.weight })); }, [userState === null || userState === void 0 ? void 0 : userState.tierId, userState === null || userState === void 0 ? void 0 : userState.weight]);
    (0, react_1.useEffect)(function () {
        if (doFetch) {
            refreshUser();
        }
    }, [doFetch, sale.fcfsMultiplier, sale.levelsOpenAll]);
    return {
        tierState: tierState,
        isCurrentTierLoading: isCurrentTierLoading,
        registeredTier: registeredTier,
        userState: userState,
        isWhitelisted: (_b = userState === null || userState === void 0 ? void 0 : userState.isWhitelisted) !== null && _b !== void 0 ? _b : false,
        allowsToBuy: (_c = userState === null || userState === void 0 ? void 0 : userState.totalAlloc.gtn(0)) !== null && _c !== void 0 ? _c : false,
        refresh: refreshUser,
        isLoading: isLoading,
    };
}
var _a = (0, constate_1.default)(useUserSaleTierRaw), UserSaleTierProvider = _a[0], useUserSaleTier = _a[1];
exports.UserSaleTierProvider = UserSaleTierProvider;
exports.useUserSaleTier = useUserSaleTier;
